/**
 * Returns the API base URL dynamically.
 * - In dev_test: derives from window.location.hostname so LAN devices
 *   can reach the API without hardcoding an IP in .env files.
 * - In staging/prod: uses the static REACT_APP_API_URL env var.
 */
export function getApiBaseUrl() {
    if (process.env.REACT_APP_BB_ENV === 'dev_test' && typeof window !== 'undefined') {
        const port = process.env.REACT_APP_API_PORT || '3006';
        return `${window.location.protocol}//${window.location.hostname}:${port}`;
    }
    return process.env.REACT_APP_API_URL;
}
